import * as actionTypes from "../../constants/actionTypes/hr/employees.constants";

export const setHrEmployees = (employees, count) => {
  return { type: actionTypes.SET_HR_EMPLOYEES, employees, count };
};

export const setHrEmployeePage = page => {
  return { type: actionTypes.SET_PAGE, page };
};

export const setHrEmployeeSearch = search => {
  return { type: actionTypes.SET_SEARCH_CHANGE, search };
};

export const toggleSidebarMenu = isSidebarOpen => {
  return { type: actionTypes.TOGGLE_SIDEBAR_MENU, isSidebarOpen };
};

export const setListOfFailedToBulkUpdateUsers = payload => {
  return { type: actionTypes.SET_FAILED_TO_BULK_UPDATE_USERS, payload };
};

export const setListOfDropdownEmployees = payload => {
  return { type: actionTypes.SET_LIST_OF_DROPDOWN_EMPLOYEES, payload };
};
export const setDropdownEmployeesFilter = payload => {
  return { type: actionTypes.SET_DROPDOWN_EMPLOYEES_FILTER, payload };
};
export const setDropdownEmployeesMeta = payload => {
  return { type: actionTypes.SET_DROPDOWN_EMPLOYEES_META, payload };
};
